import { render, staticRenderFns } from "./BiddingItem.vue?vue&type=template&id=55599142&scoped=true&"
import script from "./BiddingItem.vue?vue&type=script&lang=js&"
export * from "./BiddingItem.vue?vue&type=script&lang=js&"
import style0 from "./BiddingItem.vue?vue&type=style&index=0&id=55599142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55599142",
  null
  
)

export default component.exports